export default __webpack_public_path__ + "static/media/DAI.a4c612e7.svg";